import { getGlobalStoreInstance } from "@/app/globalStore/globalStore";

/**
 * Interceptor for API responses to extract and store server time
 * @param headers Response headers from the API
 */
export function interceptResponseHeaders(headers: Headers): void {
  if (!headers) return;

  const xServerTime = headers.get("x-server-time");

  if (xServerTime) {
    try {
      const store = getGlobalStoreInstance();
      store.getState().setServerTime(xServerTime);
    } catch (error) {
      console.error("Failed to store server time:", error);
    }
  }
}
